module.exports = __webpack_public_path__ + "static/media/arrowSelfProduction.b126fae3.svg";